import { z } from 'zod';
/** A clinic-owned link, passed to the customer without fetching its contents. */
export const externalConsentFormUrlSchema = z
    .string()
    .trim()
    .max(2048)
    .url()
    .refine((value) => {
    try {
        const url = new URL(value);
        return url.protocol === 'https:' && !url.username && !url.password;
    }
    catch {
        return false;
    }
}, 'Enter an https:// link without a username or password');
//# sourceMappingURL=external-consent-forms.js.map